<template>
  <div class="file-list">
    <!-- 卡片视图区域 -->
    <el-card>
      <!-- 搜索与添加区域 -->
      <el-row :gutter="20">
        <el-col :span='6'>
          <span>文件名：</span>
          <el-input size="small" v-model="queryInfo.form.fileName" clearable @clear="getFileList">
          </el-input>
        </el-col>
        <el-col :span='6'>
          <span>项目名称：</span>
          <el-input size="small" v-model="queryInfo.form.name" clearable @clear="getFileList"></el-input>
        </el-col>
        <el-col :span='6'>
          <span>项目编码：</span>
          <el-input size="small" v-model="queryInfo.form.code" clearable @clear="getFileList"></el-input>
        </el-col>
        <el-col :span='6'>
          <span>文件标签：</span>

          <el-input size="small" v-model="queryInfo.form.tag" clearable @clear="getFileList"></el-input>
        </el-col>
      </el-row>

      <el-row type="flex" justify="space-between">
        <el-col :span='12'>
          <span>时 间：</span>
          <el-date-picker v-model="queryInfo.form.createTime" size="small" value-format="yyyy-MM-dd" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </el-col>
        <el-col class="btns">
          <!-- <el-button icon="el-icon-document-add" size="small" class="new" @click="create">新建</el-button> -->
          <!-- <el-button icon="el-icon-upload2" size="small" class="import" @click="importFile">导入</el-button> -->
          <el-button size="small" class="reset" @click="reset">重置</el-button>
          <el-button v-on:click="getFileList" size="small" class="query">查询</el-button>
        </el-col>
      </el-row>
      <!-- 项目列表区域 -->
      <el-table :data="fileList" stripe header-row-class-name="theader">
        <el-table-column label="序号" prop="id" type="index" :index="indexMethod" width="50px"></el-table-column>
        <el-table-column label="文件名称" prop="fileName"></el-table-column>
        <el-table-column label="文件标签" prop="tag"></el-table-column>
        <el-table-column label="项目名称" prop="name"></el-table-column>
        <el-table-column label="项目编码" prop="code"></el-table-column>

        <el-table-column label="建立时间">
          <template slot-scope="scope">
            {{scope.row.createTime|dateFormat('YYYY-MM-DD')}}
          </template>
        </el-table-column>

        <el-table-column label="操作" class-name='opt-box'>
          <template slot-scope="scope">
            <!-- 修改按钮 -->
            <el-button size="mini" @click="preview(scope.row)" class="detail">预览</el-button>
            <el-button size="mini" type="danger" @click="download(scope.row)">下载</el-button>

          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.page" :page-sizes="[20, 50,100,200]" :page-size="queryInfo.size" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-card>

    <!-- 商品搜索框 -->
    <preview-box ref="preview"></preview-box>

  </div>
</template>

<script>
import commonData from '../../common/commonData'
import * as projectApi from '../../api/projectAPI'
import * as fileApi from '../../api/fileAPI'
import previewBox from '../subcomponents/preview.vue'

import moment from 'moment'
export default {
  data() {
    return {
      // 获取用户列表的参数对象
      queryInfo: {
        form: {
          createTime: [],
        },
        // 当前的页数
        page: 1,
        // 当前每页显示多少条数据
        size: 20,

      },
      fileList: [],
      total: 0,

      userInfo: {},
      pickerOptions: {},
      statusMap: {},
      stageMap: {},
      subjectMap: {}
    }
  },
  async created() {
    this.queryInfo.page = Number.parseInt(this.$route.query.page || 1);
    this.queryInfo.size = Number.parseInt(this.$route.query.size || 20);
    this.pickerOptions = commonData.pickerOptions;
    this.stageMap = commonData.stage;
    this.subjectMap = commonData.subject
    this.userInfo = await this.$store.getters.getUserInfo
    this.getFileList()
  },
  methods: {
    async getFileList() {
      let param = { ...this.queryInfo }

      let res = await projectApi.fileList(param)
      if (res.flag) {
        this.fileList = res.data.list
        this.total = res.data.total
      }
    },


    // 监听 size 改变的事件
    handleSizeChange(newSize) {
      // console.log(newSize)
      this.queryInfo.size = newSize
      this.getFileList()
    },
    // 监听 页码值 改变的事件
    handleCurrentChange(newPage) {
      console.log(newPage)
      this.queryInfo.page = newPage
      this.getFileList()
    },



    getTagType(status) {
      var json = { 0: 'info', 1: "info", 2: '', 3: 'success', 4: 'info', 5: '', 6: 'danger' }
      return json[status];
    },
    getStatus(row) {
      let status = this.statusMap[row.state]
      if (row.is_plan == 1) {
        status = this.statusMap1[row.state]
      }
      return status
    },
    reset() {
      this.queryInfo.form = {}
    },
    create() {
      this.$router.push("/addcust");
    },
    async preview(file) {
      let fileName = file.fileName
      let uuid = file.uuid
      let suffName = fileName.substring(fileName.lastIndexOf('.') + 1)
      console.log('预览pdf', fileName, suffName)
      let offices = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'pdf']
      let imgs = ['jpg', 'jpeg', 'png', 'gif', 'bmp']
      if (!offices.includes(suffName) && !imgs.includes(suffName) && 'txt' != suffName) {

        return
      }
      let res = await fileApi.preview({ uuid, suffName, fileName })
      console.log("handlePreview", suffName);
      if (offices.includes(suffName)) {
        let blob = new Blob([res], { type: 'application/pdf' })
        let href = URL.createObjectURL(blob)
        console.warn(href)
        this.$refs.preview.fileSrc = href
        // this.src = `./pdf/web/viewer.html?file=${encodeURIComponent(href)}`
        //window.open(`./pdf/web/viewer.html?file=${encodeURIComponent(href)}`);
        //this.src = this.getObjectURL(res)
        this.$refs.preview.fileVisible = true
      } else if (imgs.includes(suffName)) {
        let blob = new Blob([res])
        let href = URL.createObjectURL(blob)
        console.warn(href)
        this.$refs.preview.imgSrc = href
        this.$refs.preview.imgVisible = true
      } else if ('txt' == suffName) {
        console.log('txt', res);
        let blob = new Blob([res], { type: 'text/plain' })
        let href = URL.createObjectURL(blob)
        console.warn(href)
        this.$refs.preview.fileSrc = href
        this.$refs.preview.fileVisible = true

      }
    },
    importFile() {


    },
    download(file) {
      fileApi.download({ type: 'project', fileName: file.fileName, uuid: file.uuid },this.getProgress).then(res => {
        const link = document.createElement('a');
        let blob = new Blob([res]);
        link.style.display = 'none';
        link.href = URL.createObjectURL(blob);

        link.setAttribute('download', file.fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link)

      })

    },
    indexMethod(index){
      return (this.queryInfo.page-1)*this.queryInfo.size+index+1
    },
    getProgress(progress){
      console.log("Progress",progress);
    }

  },
  components: {
    previewBox
  }
}
</script>

<style lang="less" >
.file-list {
  .el-row {
    display: flex;
    .el-col {
      display: flex;
      font-size: 14px;
      color: #3c4353;
      margin-bottom: 20px;
      align-items: center;
      > span {
        white-space: nowrap;
        min-width: 70px;
        text-align: right;
      }
      .el-select {
        width: 100%;
      }
    }
    .btns {
      justify-content: flex-end;
      .new {
        background: #dde5ff;
        border: none;
        color: #5373f5;
        width: 80px;
      }
      .query {
        border: none;
        background: #5373f5;
        color: #fff;
        width: 80px;
      }
      .reset {
        border: none;
        background: #e6e9ef;
        color: #666666;
        width: 80px;
      }
      .import {
        border: none;
        background: #fff2d1;
        color: #f1b535;
        width: 80px;
      }
    }
  }

  .opt-box {
    .cell {
      padding-left: 10px;
      padding-right: 0;
      .detail {
        background: #5373f5;
        color: #fff;
        border: none;
      }
    }
  }
  .theader th {
    background: #e6e9ef !important;
    color: #3c4353;
    border-color: #e5e5e5;
  }
}
.el-tooltip__popper.is-dark {
  white-space: nowrap;
}
</style>
